import { EyeIcon } from '@heroicons/react/24/solid'
import Display from './Display'

const DownloadButton = ({title, onClick}) => (
  <button 
    onClick={onClick}
    className="btn btn-xs btn-ghost btn-square p-1 hover:bg-primary-400"
    title={`Voir ${title}`} aria-label={`Voir ${title}`}
  >
    <EyeIcon/>
  </button>
)

// TODO Injecter le fileFieldName s'il n'est pas renseigné directement depuis ici

export default ({item, label, name, title, uploadFormComponent = null }) => {

    const file = item ? item[name] : null

    const handleClick = (e) => {
      e.preventDefault()
      e.stopPropagation()
      window.open(file.url , '_blank')
    }

    return (
      <div className="flex items-center justify-start w-full">
        <Display label={label} 
          className="flex items-center mb-2 max-w-9/10"
          labelClassName="" 
          valueClassName="overflow-hidden max-w-3/4 text-nowrap"
        >
          { file?.filename ?
              file?.url ? 
                <button title={`Voir ${title}`} className="flex cursor-pointer" onClick={handleClick}>
                  <span>{file.filename}</span>
                </button> :
                <span>{file.filename}</span> :
                null
          }
        </Display>
        <div className="flex mb-2 ml-2 mr-4">
          { !file && uploadFormComponent }
          { !!file?.url &&
            <DownloadButton title={title} onClick={handleClick} />
          }
        </div>
      </div>
    )
  }